import { EnumScales } from '@library/store/measures/measures.interface'

export const scalesCrowdinKeys = [
  {value: EnumScales.DAY, label: 'common-app.__WEB_FORECAST_SCALE_DAY'},
  {value: EnumScales.WEEK, label: 'common-app.__WEB_FORECAST_SCALE_WEEK'},
  {value: EnumScales.MONTH_DAILY, label: 'common-app.__WEB_FORECAST_SCALE_MONTH'},
  {value: EnumScales.YEAR, label: 'common-app.__WEB_FORECAST_SCALE_YEAR'},
];
